import { Button, Col, Descriptions, Form, Input, Row, Select, Space, Table, Typography } from 'antd';
import { ColumnProps } from 'antd/es/table';
import Icons from 'assets/icons';
import React, { useEffect } from 'react';

const columns: ColumnProps<any>[] = [
  {
    key: 'maChuongTrinh',
    dataIndex: 'maChuongTrinh',
    title: 'Tên chương trình'
  }
]

const StatusContent = (props) => {
  const {previewData, closeModal} = props;
  useEffect(() => {
  }, [previewData])
  return (
    <div className='detail-info'>
      <Row>
          <Descriptions bordered
            column={{xxl: 1, lg: 1, md: 1, sm: 1, xl: 1, xs: 1}}
            style={{width: '100%'}}
            labelStyle={{
              width: '20%'
            }}
            size='small'
          >
            <Descriptions.Item label={'Mã chương trình'}>{previewData.maChuongTrinh}</Descriptions.Item>
            <Descriptions.Item label={'Tên chương trình'}>{previewData.tenChuongTrinh}</Descriptions.Item>
            <Descriptions.Item label={'Ngày tạo'}>{previewData.ngayTao}</Descriptions.Item>
            <Descriptions.Item label={'Người duyệt'}>{previewData.maChuongTrinh}</Descriptions.Item>
            <Descriptions.Item label={'Áp dụng từ'}>{previewData.apDungTu}</Descriptions.Item>
            <Descriptions.Item label={'Áp dụng đến'}>{previewData.apDungDen}</Descriptions.Item>
            <Descriptions.Item label={'Số lượt sử dụng'}>{previewData.soLuotSuDung}</Descriptions.Item>
            <Descriptions.Item label={'Trạng thái'}>{previewData.trangThai}</Descriptions.Item>
            <Descriptions.Item label={'Giá thành'}>{previewData.giaThanh}</Descriptions.Item>
            <Descriptions.Item label={'Giá giảm'}>{previewData.giaGiam}</Descriptions.Item>
            <Descriptions.Item label={'Giá giảm %'}>{previewData.giaGiamPT}</Descriptions.Item>
            <Descriptions.Item label={'Mô tả'}>{previewData.moTa}</Descriptions.Item>
            <Descriptions.Item label={'Điều kiện áp dụng khác'}>{previewData.dieuKienApDungKhac}</Descriptions.Item>
          </Descriptions>
      </Row>
      <Row justify={'space-between'} align={'middle'}
        style={{marginTop: '8px'}}
      >
        <Space direction='horizontal'>
          <Button
            type="default"
            icon={<Icons.remove />}
            size='small'
            danger
          >
            Xóa ưu đãi
          </Button>
          <Button
            type="default"
            icon={<Icons.printer />}
            size='small'
          >
            In ưu đãi
          </Button>
          <Button
            type="default"
            icon={<Icons.edit />}
            size='small'
          >
            Sửa ưu đãi
          </Button>
        </Space>
        <Space>
          <Button type='primary' onClick={closeModal} danger size='large'>
            Đóng
          </Button>
          <Button type="primary" onClick={closeModal} size='large'>
            Xác nhận
          </Button>
        </Space>
      </Row>
    </div>
  );
};

export default StatusContent;